import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom"
import { FaClipboardList, FaBuilding, FaCreditCard } from "react-icons/fa"
import { GetCountryData, GetStatesData } from "../services/Webservices"
import axios from "axios"
import { localserver } from "../../../api/common"
import { showToast, ToastMessage } from "../../Shared/ToastMessage"
import Organization from "./Organization"
import PaymentMethods from "./PaymentMethods"
import { uploadFilesAWS } from "../../../api/Webservices"
import { useUser } from "../../AdminUsers/UserContext"

const PaymentSettings = () => {
  const { checkPermission, getValidation } = useUser()
  const [errors, setErrors] = useState({
    organizationName: "",
    country: "",
    state: "",
  })
  const [isLoading, setIsLoading] = useState(false)
  const [apiError, setApiError] = useState("")
  const [eventId, setEventId] = useState("")

  // Organization details
  const [organizationName, setOrganizationName] = useState("")
  const [addressLineOne, setAddressLineOne] = useState("")
  const [addressLineTwo, setAddressLineTwo] = useState("")
  const [pinCode, setPinCode] = useState("")
  const [organizationLogo, setOrganizationLogo] = useState("")
  const [uploadedLogo, setUploadedLogo] = useState(null)
  // Image upload
  const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/jpg"]
  const MAX_IMAGE_SIZE = 5 * 1024 * 1024 // 5MB
  const [imageError, setImageError] = useState("")

  // Payment Methods details
  const [onlinePaymentEnabled, setOnlinePaymentEnabled] = useState("no")
  const [payAtVenueEnabled, setPayAtVenueEnabled] = useState("no")
  const [bankTransferEnabled, setBankTransferEnabled] = useState("no")
  const [chequePaymentEnabled, setChequePaymentEnabled] = useState("no")
  const [onlineThankYou, setOnlineThankYou] = useState("")
  const [razorpayPublishKey, setRazorpayPublishKey] = useState("")
  const [razorpaySecretKey, setRazorpaySecretKey] = useState("")
  const [venueThankYou, setVenueThankYou] = useState("")
  const [bankThankYou, setBankThankYou] = useState("")
  const [chequeThankYou, setChequeThankYou] = useState("")
  const [bankDetails, setBankDetails] = useState("")
  const [includeQR, setIncludeQR] = useState(false)
  const [mandatoryTransaction, setMandatoryTransaction] = useState(false)
  const [beneficiaryName, setBeneficiaryName] = useState("")
  const [chequeAddress, setChequeAddress] = useState("")

  // Invoice & Receipts details
  const [taxType, setTaxType] = useState("")
  const [taxName, setTaxName] = useState("")
  const [taxPercentage, setTaxPercentage] = useState(0)
  const [taxApplicability, setTaxApplicability] = useState("no")
  const [registrationIdPrefix, setRegistrationIdPrefix] = useState("")
  const [registrationStartingNumber, setRegistrationStartingNumber] = useState(0)
  const [registrationIdSuffix, setRegistrationIdSuffix] = useState("")
  const [salesEndDateTime, setSalesEndDateTime] = useState("")
  const [allowSalesUntilEventStart, setAllowSalesUntilEventStart] = useState("no")
  const [salesEndHoursBeforeEvent, setSalesEndHoursBeforeEvent] = useState(0)
  const [allowTicketEdit, setAllowTicketEdit] = useState("no")
  const [editHoursBeforeEvent, setEditHoursBeforeEvent] = useState(0)
  const [allowTicketCancel, setAllowTicketCancel] = useState("no")
  const [cancelHoursBeforeEvent, setCancelHoursBeforeEvent] = useState(0)
  const [allowAttendeeLogin, setAllowAttendeeLogin] = useState("no")
  const [allowAttendeeEditRegistration, setAllowAttendeeEditRegistration] = useState("no")
  const [addOnsEnabled, setAddOnsEnabled] = useState("no")
  const [generateTaxInvoice, setGenerateTaxInvoice] = useState("no")
  const [generatePaymentReceipt, setGeneratePaymentReceipt] = useState("no")
  const [thankYouMessage, setThankYouMessage] = useState("")

  // Venue details (minimal)
  const [venueCountry, setVenueCountry] = useState("")
  const [venueCity, setVenueCity] = useState("")
  const [venueState, setVenueState] = useState("")
  const [countryData, setCountryData] = useState([])
  const [stateList, setStateList] = useState([])

  const [activePage, setActivePage] = useState("organization")

  const topics = [
    { id: "organization", label: "Organization", icon: <FaBuilding size={18} />, description: "" },
    { id: "payment-methods", label: "Payment Methods", icon: <FaCreditCard size={18} />, description: "" },
    // { id: "invoice-receipts", label: "Invoice & Receipts", icon: <FaMapMarkerAlt size={18} />, description: "" }
  ]

  const getCountries = async () => {
    try {
      const countries = await GetCountryData()
      setCountryData(countries)
    } catch (error) {
      console.error("Error fetching countries:", error)
    }
  }

  const handleCountrydata = async (countryId) => {
    setVenueCountry(countryId)
    try {
      const states = await GetStatesData(countryId)
      setStateList(states)
      if (venueState && states.length > 0 && !states.find((s) => s.id === venueState)) {
        setVenueState("")
      }
    } catch (error) {
      console.error("Error fetching states:", error)
    }
  }

  const MIN_DIMENSION = 90 // Minimum acceptable width or height
  const MAX_DIMENSION = 160 // Maximum acceptable width or height

  const validateImage = (file, type) => {
    if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
      return `${type === "logo" ? "Event logo" : "Venue photo"} must be JPG, JPEG, or PNG format.`
    }
    if (file.size > MAX_IMAGE_SIZE) {
      return `${type === "logo" ? "Event logo" : "Venue photo"} size must not exceed 5MB.`
    }
    return new Promise((resolve) => {
      const img = new Image()
      const objectUrl = URL.createObjectURL(file)
      img.onload = () => {
        console.log(`Image dimensions: ${img.width} × ${img.height}`)
        const isWidthValid = img.width >= MIN_DIMENSION && img.width <= MAX_DIMENSION
        const isHeightValid = img.height >= MIN_DIMENSION && img.height <= MAX_DIMENSION
        if (
          !(isWidthValid && isHeightValid) ||
          (img.width !== 150 && img.height !== 100 && img.width !== 100 && img.height !== 150)
        ) {
          URL.revokeObjectURL(objectUrl)
          resolve(
            `${type === "logo" ? "Event logo" : "Venue photo"} dimensions must be approximately 150 × 100 or 100 × 150 pixels (within 90-160 × 90-160).`,
          )
        } else {
          URL.revokeObjectURL(objectUrl)
          resolve(null)
        }
      }
      img.onerror = () => {
        URL.revokeObjectURL(objectUrl)
        resolve(`Failed to load ${type === "logo" ? "Event logo" : "Venue photo"}. Please try again.`)
      }
      img.src = objectUrl
    })
  }

  const handleFileChange = (type) => async (event) => {
    const file = event.target.files[0]
    if (!file) return

    const validationError = await validateImage(file, type)
    if (validationError) {
      setImageError(validationError)
      return
    }

    try {
      const res = await uploadFilesAWS({ upload_files: file })
      if (res.data && res.data.success === true) {
        const uploadedUrl = res.data.uploadedUrls.upload_files[0]
        console.log(`${type} uploaded URL:`, uploadedUrl)
        setOrganizationLogo(uploadedUrl)
        setUploadedLogo(URL.createObjectURL(file))
        setImageError("")
        await handleSaveEvent(uploadedUrl, file)
      } else {
        showToast(res.message, "error")
      }
    } catch (error) {
      console.error(`Error uploading ${type}:`, error)
      showToast(`Failed to upload ${type}. Please try again.`, "error")
    }
  }

  const formatDateToMySQL = (dateString) => {
    if (!dateString) return ""
    const date = new Date(dateString)
    if (isNaN(date.getTime())) return ""
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const day = String(date.getDate()).padStart(2, "0")
    const hours = String(date.getHours()).padStart(2, "0")
    const minutes = String(date.getMinutes()).padStart(2, "0")
    const seconds = String(date.getSeconds()).padStart(2, "0")
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
  }

  const handleSaveEvent = async (logoUrl = "", logoFile = null) => {
    const hasPermission = await checkPermission("Payment settings", "update")
    if (!hasPermission) return
    setIsLoading(true)
    setApiError("")
    let hasErrors = false

    const newErrors = {}
    if (!organizationName) {
      newErrors.organizationName = "Organization name is required."
      hasErrors = true
    }
    if (!venueCountry) {
      newErrors.country = "Organization country is required."
      hasErrors = true
    }
    if (!venueState) {
      newErrors.state = "Organization state is required."
      hasErrors = true
    }
    setErrors(newErrors)
    if (hasErrors) {
      setIsLoading(false)
      showToast("Fill all required fields", "error")
      return
    }

    try {
      const Payload = {
        event_id: localStorage.getItem("eventId") || "",
        organization_name: organizationName,
        logo_url: organizationLogo || "",
        address_line1: addressLineOne,
        address_line2: addressLineTwo,
        country: venueCountry,
        state: venueState,
        city: venueCity,
        postcode: pinCode,
        online_payment_enabled: onlinePaymentEnabled,
        payment_key: razorpayPublishKey,
        payment_secret: razorpaySecretKey,
        pay_at_venue_enabled: payAtVenueEnabled,
        bank_transfer_enabled: bankTransferEnabled,
        cheque_payment_enabled: chequePaymentEnabled,
        registration_id_prefix: registrationIdPrefix,
        registration_starting_number: registrationStartingNumber,
        registration_id_suffix: registrationIdSuffix,
        online_thank_you: onlineThankYou,
        venue_thank_you: venueThankYou,
        bank_thank_you: bankThankYou,
        cheque_thank_you: chequeThankYou,
        bank_details: bankDetails,
        include_qr: includeQR ? "yes" : "no",
        mandatory_transaction: mandatoryTransaction ? "yes" : "no",
        beneficiary_name: beneficiaryName,
        cheque_address: chequeAddress,
      }
      console.log("Saving payload: ", Payload)

      const endpoint = "/create_update_event_settings"
      const response = await axios.post(`${localserver}${endpoint}`, Payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      })

      if (response.data.success) {
        showToast("Settings saved successfully.", "success")
        setEventId(response.data.event_id)
        getValidation();
      } else {
        throw new Error(response.data.message || "Failed to save settings")
      }
    } catch (error) {
      setApiError(error.message || "An error occurred while saving the settings.")
      showToast(error.message || "An error occurred while saving the settings.", "error")
    } finally {
      setIsLoading(false)
    }
  }

  const getEventById = async (event_id) => {
    try {
      const response = await axios.post(
        `${localserver}/get_event_configurationsettings`,
        { event_id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        },
      )
      if (response.data.success) {
        const event = response.data.data[0]
        console.log("Fetched event data:", event)
        setEventId(event.id)
        setOrganizationName(event.organization_name || "")
        setAddressLineOne(event.address_line1 || "")
        setAddressLineTwo(event.address_line2 || "")
        setVenueCountry(event.country || "")
        setVenueState(event.state || "")
        setVenueCity(event.city || "")
        setPinCode(event.postcode || "")
        setOrganizationLogo(event.logo_url || "")
        setUploadedLogo(event.logo_url || "")
        setOnlinePaymentEnabled(event.online_payment_enabled || "no")
        setRazorpayPublishKey(event.payment_key || "")
        setRazorpaySecretKey(event.payment_secret || "")
        setPayAtVenueEnabled(event.pay_at_venue_enabled || "no")
        setBankTransferEnabled(event.bank_transfer_enabled || "no")
        setChequePaymentEnabled(event.cheque_payment_enabled || "no")
        setOnlineThankYou(event.online_thank_you || "")
        setVenueThankYou(event.venue_thank_you || "")
        setBankThankYou(event.bank_thank_you || "")
        setChequeThankYou(event.cheque_thank_you || "")
        setBankDetails(event.bank_details || "")
        setIncludeQR(event.include_qr === "yes")
        setMandatoryTransaction(event.mandatory_transaction === "yes")
        setBeneficiaryName(event.beneficiary_name || "")
        setChequeAddress(event.cheque_address || "")
      } else {
        console.error("Error: Failed to fetch event data")
      }
    } catch (error) {
      console.error("Error fetching event data:", error)
    }
  }

  useEffect(() => {
    const eventId = localStorage.getItem("eventId")
    if (eventId) {
      getEventById(eventId)
    }
    getCountries()
  }, [])

  // Check Admin User Permission
  const [checkUserLoading, setCheckUserLoading] = useState(false)
  const fetchPermission = async () => {
    setCheckUserLoading(true)
    try {
      const hasPermission = await checkPermission("Payment settings", "view")
      if (!hasPermission) return
    } catch (error) {
      console.error("Error Check Permission:", error)
    } finally {
      setCheckUserLoading(false)
    }
  }
  useEffect(() => {
    fetchPermission()
  }, [])

  useEffect(() => {
    if (venueCountry) {
      handleCountrydata(venueCountry)
    }
  }, [venueCountry])

  useEffect(() => {
    console.log("Payment method states:", {
      onlinePaymentEnabled,
      payAtVenueEnabled,
      bankTransferEnabled,
      chequePaymentEnabled,
    })
  }, [onlinePaymentEnabled, payAtVenueEnabled, bankTransferEnabled, chequePaymentEnabled])

  const renderHeader = () => (
    // <div style={{ marginBottom: "16px" }}>
    //   <div
    //     style={{
    //       margin: "0 auto",
    //       padding: "0 2rem",
    //       backgroundColor: "#ffffff",
    //       boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    //       borderRadius: "12px",
    //     }}
    //   >
    //     <div
    //       style={{
    //         display: "flex",
    //         justifyContent: "space-between",
    //         alignItems: "center",
    //         padding: "1.5rem 0",
    //       }}
    //     >
    //       <div
    //         style={{
    //           display: "flex",
    //           flexDirection: "column",
    //           gap: "0.75rem",
    //         }}
    //       >
    //         <div
    //           style={{
    //             display: "flex",
    //             alignItems: "center",
    //             gap: "1rem",
    //           }}
    //         >
    //           <h1
    //             style={{
    //               fontSize: "2rem",
    //               fontWeight: "700",
    //               color: "#1f2937",
    //               margin: 0,
    //               lineHeight: "1.2",
    //             }}
    //           >
    //             Payment Settings
    //           </h1>
    //         </div>
    //         <nav
    //           style={{
    //             display: "flex",
    //             alignItems: "center",
    //             gap: "0.5rem",
    //             fontSize: "0.875rem",
    //           }}
    //         >
    //           <Link
    //             to="/events/admin/"
    //             style={{
    //               color: "#184778",
    //               textDecoration: "none",
    //               fontWeight: "500",
    //               transition: "color 0.2s ease",
    //             }}
    //           >
    //             AMASI
    //           </Link>
    //           <span style={{ color: "#9ca3af", fontSize: "1rem" }}>/</span>
    //           <span style={{ color: "#6b7280" }}>Payment Settings</span>
    //         </nav>
    //       </div>
    //     </div>
    //   </div>
    // </div>
       <div style={{ marginBottom: "22px" }}>
      <div className="brood_comes_div">
        <div className="row align-items-center">
          <div className="col-md-6 brood_comes_heading">
            <h2>
              <div className="brood_comes_part">
                {/* <FaCheck /> */}
          <i class="fa fa-credit-card"></i>
              </div>
              Payment Settings
            </h2>

          </div>
          <div className="col-md-6 text-end">

          </div>
        </div>
      </div>
    </div>
  )

  const renderNavigationTabs = () => (
    <div style={{ marginBottom: "22px" }}>
      <div
        style={{
          margin: "0 auto",
          padding: "15px 24px",
          backgroundColor: "#ffffff",
          boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
          borderRadius: "12px",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "0.5rem",
          
          }}
        >
          {topics.map((topic) => (
            <button
              key={topic.id}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.75rem",
                padding: "5px 20px",
                backgroundColor: activePage === topic.id ? "#184778" : "#f8fafc",
                border: activePage === topic.id ? "1px solid #184778" : "1px solid #e2e8f0",
                borderRadius: "10px",
                cursor: "pointer",
                transition: "all 0.3s ease",
                textAlign: "left",
                minHeight: "65px",
                ...(activePage === topic.id
                  ? {
                      color: "#ffffff",
                      boxShadow: "0 4px 6px -1px rgba(24, 71, 120, 0.3)",
                      transform: "translateY(-2px)",
                    }
                  : {}),
              }}
              onClick={() => setActivePage(topic.id)}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "40px",
                  height: "40px",
                  borderRadius: "10px",
                  backgroundColor: activePage === topic.id ? "rgba(255, 255, 255, 0.2)" : "#e2e8f0",
                  color: activePage === topic.id ? "#ffffff" : "#64748b",
                  transition: "all 0.3s ease",
                  flexShrink: 0,
                }}
              >
                {topic.icon}
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.25rem",
                  flex: 1,
                }}
              >
                <span
                  style={{
                    fontSize: "0.875rem",
                    fontWeight: "600",
                    color: activePage === topic.id ? "#ffffff" : "#374151",
                    transition: "color 0.3s ease",
                  }}
                >
                  {topic.label}
                </span>
                <span
                  style={{
                    fontSize: "0.75rem",
                    color: activePage === topic.id ? "rgba(255, 255, 255, 0.8)" : "#9ca3af",
                    transition: "color 0.3s ease",
                  }}
                >
                  {topic.description}
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  )

  const renderMainContent = () => (
    <div style={{ flex: 1 }}>
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "16px",
          boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
          overflow: "hidden",
        }}
      >
        {activePage === "organization" && (
          <div style={{ padding: "2rem" }}>
            <div
              style={{
                    marginBottom: "22px",
                paddingBottom: "15px",
                borderBottom: "1px solid #e5e7eb",
              }}
            >
              <h2
                style={{
                  fontSize: "20px",
                  fontWeight: "700",
                  color: "#1f2937",
                  margin: "0 0 0.5rem 0",
                }}
              >
                Organization
              </h2>
            </div>
            <Organization
              handleFileChange={handleFileChange}
              handleSaveEvent={handleSaveEvent}
              uploadedLogo={uploadedLogo}
              organizationName={organizationName}
              setOrganizationName={setOrganizationName}
              addressLineOne={addressLineOne}
              setAddressLineOne={setAddressLineOne}
              addressLineTwo={addressLineTwo}
              setAddressLineTwo={setAddressLineTwo}
              pinCode={pinCode}
              setPinCode={setPinCode}
              errors={errors}
              city={venueCity}
              setCity={setVenueCity}
              country={venueCountry}
              state={venueState}
              setState={setVenueState}
              handleCountrydata={handleCountrydata}
              countryList={countryData}
              stateList={stateList}
              imageError={imageError}
            />
          </div>
        )}
        {activePage === "payment-methods" && (
          <div style={{ padding: "2rem" }}>
            <div
              style={{
                marginBottom: "22px",
                paddingBottom: "15px",
                borderBottom: "1px solid #e5e7eb",
              }}
            >
              <h2
                style={{
                    fontSize: "20px",
                  fontWeight: "700",
                  color: "#1f2937",
                  margin: "0 0 0.5rem 0",
                }}
              >
                Payment Methods
              </h2>
            </div>
            <PaymentMethods
              handleSaveEvent={handleSaveEvent}
              onlinePaymentEnabled={onlinePaymentEnabled}
              setOnlinePaymentEnabled={setOnlinePaymentEnabled}
              razorpayPublishKey={razorpayPublishKey}
              razorpaySecretKey={razorpaySecretKey}
              setRazorpayPublishKey={setRazorpayPublishKey}
              setRazorpaySecretKey={setRazorpaySecretKey}
              payAtVenueEnabled={payAtVenueEnabled}
              setPayAtVenueEnabled={setPayAtVenueEnabled}
              bankTransferEnabled={bankTransferEnabled}
              setBankTransferEnabled={setBankTransferEnabled}
              chequePaymentEnabled={chequePaymentEnabled}
              setChequePaymentEnabled={setChequePaymentEnabled}
              onlineThankYou={onlineThankYou}
              setOnlineThankYou={setOnlineThankYou}
              venueThankYou={venueThankYou}
              setVenueThankYou={setVenueThankYou}
              bankThankYou={bankThankYou}
              setBankThankYou={setBankThankYou}
              chequeThankYou={chequeThankYou}
              setChequeThankYou={setChequeThankYou}
              bankDetails={bankDetails}
              setBankDetails={setBankDetails}
              includeQR={includeQR}
              setIncludeQR={setIncludeQR}
              mandatoryTransaction={mandatoryTransaction}
              setMandatoryTransaction={setMandatoryTransaction}
              beneficiaryName={beneficiaryName}
              setBeneficiaryName={setBeneficiaryName}
              chequeAddress={chequeAddress}
              setChequeAddress={setChequeAddress}
              getValidation={getValidation}
            />
          </div>
        )}
      </div>
    </div>
  )

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f8fafc", padding: "24px 15px" }}>
      <ToastMessage />
      {renderHeader()}
      {renderNavigationTabs()}
      <div style={{ display: "flex", gap: "24px", alignItems: "flex-start" }}>{renderMainContent()}</div>
    </div>
  )
}

export default PaymentSettings
